// src/redux/eventReducer.js

import { SET_EVENT_DATA } from "./Action/EventActions";

const initialState = {
  eventId: null,
  eventSlug: null,
  eventTitle: null,
};

export default function viewEventData(state = initialState, action) {
  switch (action.type) {
    case SET_EVENT_DATA:
      return {
        ...state,
        eventId: action.payload.eventId,
        eventSlug: action.payload.eventSlug,
        eventTitle: action.payload.eventTitle,
      };

    default:
      return state;
  }
}
